import { ThemeName, metaThemeColor } from "./palette";

export const applyToDocument = (effective: ThemeName): void => {
  const el = document.documentElement;
  el.setAttribute("data-theme", effective);
  el.style.colorScheme = effective;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", metaThemeColor[effective]);
};
